
import React from 'react';
import AiChatBox from '@/components/AiChatBox';
import { useTranslation } from 'react-i18next';

interface ChatHistoryProps {
  onSubmit: (question: string) => void;
  onResponse: (response: string) => void;
  context: string;
  chat: { question: string; answer: string }[];
}

const ChatHistory = ({ onSubmit, onResponse, context, chat }: ChatHistoryProps) => {
  const { t } = useTranslation();
  return (
    <div className="mt-6 border-t pt-4">
      <h4 className="font-medium mb-4">{t('ai.askQuestion')}</h4>
      <AiChatBox 
        onSubmit={onSubmit}
        onResponse={onResponse}
        context={context}
      />
      
      {chat.map((chatItem, index) => (
        <div key={`chat-${index}-${chatItem.question.substring(0, 20)}`} className="mt-4 bg-white p-4 rounded-lg">
          <p className="font-medium mb-2">{t('ai.question')} {chatItem.question}</p>
          <p className="text-gray-600">{t('ai.response')} {chatItem.answer}</p>
        </div>
      ))}
    </div>
  );
};

export default ChatHistory;
